/* eslint-disable @ngrx/no-dispatch-in-effects */
/* eslint-disable @ngrx/prefer-effect-callback-in-block-statement */
import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';

@Injectable()
export class ngRxEffects {
	// loadResources$ = createEffect(() =>
	// 	this.actions$.pipe(
	// 		ofType(LearningActions.loadResources),
	// 		concatLatestFrom(actions =>
	// 			this.store.select(
	// 				selectApiStatus(actions.cohortId, LearningOption.resources),
	// 			),
	// 		),
	// 		filter(([, apiStatus]) => apiStatus === InterfaceAPIStatus.none),
	// 		tap(([actions]) =>
	// 			this.store.dispatch(
	// 				LearningActions.loadLearningApiStatus({
	// 					status: InterfaceAPIStatus.start,
	// 					cohortId: actions.cohortId,
	// 					option: LearningOption.resources,
	// 				}),
	// 			),
	// 		),
	// 		concatMap(([actions]) =>
	// 			this.learningService.loadResources(actions.cohortId).pipe(
	// 				map(data => ({
	// 					data,
	// 					actions,
	// 				})),
	// 			),
	// 		),
	// 		map(data =>
	// 			LearningActions.loadLearningSuccess({
	// 				cohortId: data.actions.cohortId,
	// 				option: LearningOption.resources,
	// 				data: data.data,
	// 			}),
	// 		),
	// 	),
	// );

	// loadNotes$ = createEffect(() =>
	// 	this.actions$.pipe(
	// 		ofType(LearningActions.loadNotes),
	// 		concatLatestFrom(actions =>
	// 			this.store.select(
	// 				selectApiStatus(actions.cohortId, LearningOption.notes),
	// 			),
	// 		),
	// 		filter(([, apiStatus]) => apiStatus === InterfaceAPIStatus.none),
	// 		tap(([actions]) =>
	// 			this.store.dispatch(
	// 				LearningActions.loadLearningApiStatus({
	// 					status: InterfaceAPIStatus.start,
	// 					cohortId: actions.cohortId,
	// 					option: LearningOption.notes,
	// 				}),
	// 			),
	// 		),
	// 		concatMap(([actions]) =>
	// 			this.learningService.loadNotes(actions.cohortId).pipe(
	// 				map(data => ({
	// 					data,
	// 					actions,
	// 				})),
	// 			),
	// 		),
	// 		map(data => {
	// 			const returnNote: any = [];
	// 			const notes = data.data;
	// 			for (const note in notes) {
	// 				const olNotes: any = notes[note];
	// 				let multimedia = '';
	// 				const uniqueValue = olNotes?.notes
	// 					?.map(no => no.slideIndex)
	// 					.filter((item, i, ar) => ar.indexOf(item) === i);
	// 				const newNotes: any = [];
	// 				for (const unique in uniqueValue) {
	// 					const firstRight = olNotes?.notes
	// 						?.filter(no => no.slideIndex === uniqueValue[unique])
	// 						.map(no => ({
	// 							...no,
	// 							formatDate: format(
	// 								new Date(no.createdAt),
	// 								`dd MMM yyyy 'at' hh:mm a`,
	// 							),
	// 						}));
	// 					newNotes.push({
	// 						...firstRight[0],
	// 						href: `https://textbook.terra.do/class/${
	// 							olNotes.classId
	// 						}?slideNumber=${firstRight[0].slideIndex + 1}`,
	// 						slides: firstRight,
	// 					});

	// 					const exMultimedia = firstRight
	// 						.filter(res => !!res.multimedia)
	// 						.filter(res => res.multimedia !== ' ')
	// 						.map(res => res.multimedia)[0];

	// 					if (!!exMultimedia) {
	// 						multimedia = exMultimedia;
	// 					}

	// 					if (!!multimedia && multimedia.indexOf('youtube.com') > -1) {
	// 						try {
	// 							const match = multimedia
	// 								.split('?')[1]
	// 								.split('&')
	// 								.filter(str => str.indexOf('v=') > -1)[0]
	// 								.split('=')[1];
	// 							multimedia = `https://img.youtube.com/vi/${match}/3.jpg`;
	// 						} catch (e) {}
	// 					}
	// 				}
	// 				returnNote.push({
	// 					classId: olNotes.classId,
	// 					classTitle: olNotes.classTitle,
	// 					classSlides: newNotes,
	// 					multimedia,
	// 				});
	// 			}
	// 			return {
	// 				actions: data.actions,
	// 				data: returnNote,
	// 			};
	// 		}),
	// 		map(data =>
	// 			LearningActions.loadLearningSuccess({
	// 				cohortId: data.actions.cohortId,
	// 				option: LearningOption.notes,
	// 				data: data.data,
	// 			}),
	// 		),
	// 	),
	// );

	// loadSyllabus$ = createEffect(() =>
	// 	this.actions$.pipe(
	// 		ofType(LearningActions.loadSyllabus),
	// 		concatLatestFrom(actions =>
	// 			this.store.select(
	// 				selectApiStatus(actions.cohortId, LearningOption.syllabus),
	// 			),
	// 		),
	// 		filter(([, apiStatus]) => apiStatus === InterfaceAPIStatus.none),
	// 		tap(([actions]) =>
	// 			this.store.dispatch(
	// 				LearningActions.loadLearningApiStatus({
	// 					status: InterfaceAPIStatus.start,
	// 					cohortId: actions.cohortId,
	// 					option: LearningOption.syllabus,
	// 				}),
	// 			),
	// 		),
	// 		concatMap(([actions]) =>
	// 			this.learningService.loadSyllabus(actions.cohortId).pipe(
	// 				map(data => ({
	// 					data: [{ longDescription: data.longDescription }],
	// 					actions,
	// 				})),
	// 			),
	// 		),
	// 		map(data =>
	// 			LearningActions.loadLearningSuccess({
	// 				cohortId: data.actions.cohortId,
	// 				option: LearningOption.syllabus,
	// 				data: data.data,
	// 			}),
	// 		),
	// 	),
	// );

	// loadModules$ = createEffect(() =>
	// 	this.actions$.pipe(
	// 		ofType(LearningActions.loadModules),
	// 		concatLatestFrom(actions =>
	// 			this.store.select(
	// 				selectApiStatus(actions.cohortId, LearningOption.modules),
	// 			),
	// 		),
	// 		filter(([, apiStatus]) => apiStatus === InterfaceAPIStatus.none),
	// 		tap(([actions]) =>
	// 			this.store.dispatch(
	// 				LearningActions.loadLearningApiStatus({
	// 					status: InterfaceAPIStatus.start,
	// 					cohortId: actions.cohortId,
	// 					option: LearningOption.modules,
	// 				}),
	// 			),
	// 		),
	// 		tap(([actions]) =>
	// 			this.store.dispatch(
	// 				LearningActions.loadClassAndEvents({
	// 					cohortId: actions.cohortId,
	// 					option: LearningOption.modules,
	// 				}),
	// 			),
	// 		),
	// 		tap(([actions]) =>
	// 			this.store.dispatch(
	// 				LearningActions.loadAssignments({
	// 					cohortId: actions.cohortId,
	// 					option: LearningOption.modules,
	// 				}),
	// 			),
	// 		),
	// 		concatMap(([actions]) =>
	// 			this.learningService.loadModules(actions.cohortId).pipe(
	// 				map(data => ({
	// 					data,
	// 					actions,
	// 				})),
	// 			),
	// 		),
	// 		map(data =>
	// 			LearningActions.loadLearningSuccess({
	// 				cohortId: data.actions.cohortId,
	// 				option: LearningOption.modules,
	// 				data: data.data,
	// 			}),
	// 		),
	// 	),
	// );

	// loadClassAndEvents$ = createEffect(() =>
	// 	this.actions$.pipe(
	// 		ofType(LearningActions.loadClassAndEvents),
	// 		concatMap(actions =>
	// 			this.learningService.loadClassAndEvents(actions.cohortId).pipe(
	// 				map(data => ({
	// 					events:
	// 						data.events &&
	// 						data.events.webinars &&
	// 						data.events.webinars.length > 0
	// 							? data.events.webinars.map(event => ({
	// 									...event,
	// 									name: 'Event: ' + event.summary,
	// 							  }))
	// 							: [],
	// 					classes: data.events.classes,
	// 					actions,
	// 				})),
	// 			),
	// 		),
	// 		map(data =>
	// 			LearningActions.loadLearningSuccess({
	// 				cohortId: data.actions.cohortId,
	// 				option: LearningOption.events,
	// 				data: data.events,
	// 			}),
	// 		),
	// 	),
	// );

	// loadAssignments$ = createEffect(() =>
	// 	this.actions$.pipe(
	// 		ofType(LearningActions.loadAssignments),
	// 		concatMap(actions =>
	// 			this.learningService.loadAssignments(actions.cohortId).pipe(
	// 				map(data => ({
	// 					assignments: data.assignments.map(event => ({
	// 						...event,
	// 						name: event.title,
	// 						type: 'assignments',
	// 					})),
	// 					actions,
	// 				})),
	// 			),
	// 		),
	// 		map(data =>
	// 			LearningActions.loadLearningSuccess({
	// 				cohortId: data.actions.cohortId,
	// 				option: LearningOption.assignment,
	// 				data: data.assignments,
	// 			}),
	// 		),
	// 	),
	// );

	// loadStudents$ = createEffect(() =>
	// 	this.actions$.pipe(
	// 		ofType(LearningActions.loadStudents),
	// 		concatLatestFrom(actions =>
	// 			this.store.select(
	// 				selectApiStatus(actions.cohortId, LearningOption.students),
	// 			),
	// 		),
	// 		filter(([, apiStatus]) => apiStatus === InterfaceAPIStatus.none),
	// 		tap(([actions]) =>
	// 			this.store.dispatch(
	// 				LearningActions.loadLearningApiStatus({
	// 					status: InterfaceAPIStatus.start,
	// 					cohortId: actions.cohortId,
	// 					option: LearningOption.students,
	// 				}),
	// 			),
	// 		),
	// 		concatMap(([actions]) =>
	// 			this.learningService.loadStudents(actions.cohortId).pipe(
	// 				map(data => ({
	// 					data,
	// 					actions,
	// 				})),
	// 			),
	// 		),
	// 		map(data =>
	// 			LearningActions.loadLearningSuccess({
	// 				cohortId: data.actions.cohortId,
	// 				option: LearningOption.students,
	// 				data: data.data,
	// 			}),
	// 		),
	// 	),
	// );

	constructor(private actions$: Actions, private store: Store) {}
}
